import { AfterViewChecked, Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from "@angular/core";
import { SupportMessageInfo } from "./shared/info/support-message-info";
import { DataService_SupportChatWindow } from "./shared/data.service";
import { ChatLogInsertRequest } from "./shared/info/chat-log-insert-request";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";

@Component({
	selector: "caass-support-chat-window",
	templateUrl: "./support-chat-window.component.html",
	styleUrls: ["./support-chat-window.component.css"],
})
export class SupportChatWindowComponent implements OnInit, AfterViewChecked {
	constructor(private dataService: DataService_SupportChatWindow, private router: Router) {}

	ngOnInit(): void {
		var initMsg: SupportMessageInfo = {
			MessageID: -1,
			MessageTypeID: 0,
			MessageText: "How can we help you today?",
			FromName: "System",
			c_date: new Date(),
		};

		this.lstMessages = [...this.lstMessages, initMsg];

		this.loadData();
	}

	ngAfterViewChecked(): void {
		this.ScrollToBottom();
	}

	//////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////

	@ViewChild("ChatBackground") private chatDiv: ElementRef;

	Hidden: boolean = false;
	Expanded: boolean = false;

	NextMessage: string = "";
	LoadingMessages: boolean = false;

	lstMessages: SupportMessageInfo[] = [];

	@HostListener("window:keydown", ["$event"])
	LogKeys(e: KeyboardEvent) {
		// Enter = Toggle
		if (e.keyCode == 13) {
			this.onSend();
		}
	}

	//////////////////////////////////////////////

	//////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////

	loadData() {
		this.LoadingMessages = true;

		var result = this.dataService.ChatLogSelectList();
		result.subscribe(
			(response: any) => {
				this.LoadingMessages = false;

				if (response != undefined && response.length > 0) {
					for (var z = 0; z < response.length; z++) {
						var next = response[z];

						var nextMessage: SupportMessageInfo = {
							MessageID: next.MessageID,
							MessageText: String(next.MessageText),
							MessageTypeID: next.MessageTypeID,
							FromName: next.FromName,
							c_date: new Date(next.c_date),
						};

						this.lstMessages = [...this.lstMessages, nextMessage];
					}
				}
			},
			(error) => {
				this.LoadingMessages = false;
			}
		);
	}

	//////////////////////////////////////////////

	//////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////

	onExpand() {
		this.Expanded = !this.Expanded;
	}

	onHide() {
		this.Hidden = !this.Hidden;
	}

	onSend() {
		if (this.NextMessage == undefined || this.NextMessage == "") {
			return;
		}

		var nextMessage: SupportMessageInfo = {
			MessageID: this.lstMessages.length + 1,
			MessageText: String(this.NextMessage),
			MessageTypeID: 1,
			FromName: "",
			c_date: new Date(),
		};

		//
		//	Update UI
		//
		this.lstMessages = [...this.lstMessages, nextMessage];
		this.NextMessage = "";

		this.ScrollToBottom();

		//
		//	Make WS Request
		//
		this.LoadingMessages = true;

		var parms: ChatLogInsertRequest = {
			MessageText: nextMessage.MessageText,
			CurrentPage: this.router.url,
		};

		var result = this.dataService.ChatLogInsert(parms);
		result.subscribe(
			(response: any) => {
				this.LoadingMessages = false;

				if (response.Success == false) {
					var errorMessage: SupportMessageInfo = {
						MessageID: this.lstMessages.length + 1,
						MessageText: "Error Sending Message: " + response.ErrorMessage,
						MessageTypeID: -1,
						FromName: "",
						c_date: new Date(),
					};

					this.lstMessages = [...this.lstMessages, errorMessage];
				}
			},
			(error) => {
				this.LoadingMessages = false;
			}
		);
	}

	onClear() {
		this.lstMessages = [];

		var result = this.dataService.ChatLogClear();
		result.subscribe(
			(response: any) => {},
			(error) => {}
		);
	}

	onContactSupport() {
		var a = document.createElement("a"); //Create <a>
		a.href = "https://www.access411.com/online-support/";
		a.target = "_blank";
		a.click(); //Downloaded file
	}

	ScrollToBottom() {
		try {
			this.chatDiv.nativeElement.scrollTop = this.chatDiv.nativeElement.scrollHeight;
		} catch (e) {
			e.toString();
		}
	}

	FormatDate(c_date: Date): string {
		if (c_date == undefined) {
			return "";
		}

		return moment(c_date).format("hh:mm");
	}

	//////////////////////////////////////////////
}
